<template>
  <div class="main_div">
    <div class="font_div">
      <vue-typed-js
          :strings="['欢迎来到桔子二手车平台!']"
          :shuffle="true"
          :typeSpeed="150"
          :fadeOutClass="'fadeOutClass'"
          :loop="false"
          :loopCount="100"
          :startDelay="500"
          :showCursor="false"
          :contentType="'html'"
      >
        <p class="typing"></p>
      </vue-typed-js>
    </div>

    <div class="form_div">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterAndLogin",
  data(){
    return{
      // typeSpeed: 100,//打字的速度
      // smartBackspace: true, // 开启智能退格 默认false
      // cursorChar: '♡',
      // backSpeed: 50,//后退速度
      // backDelay: 500,//后退延迟
      // loop:true,//是否循环
      // startDelay:1000,//起始时间
      // fadeOut:true,//淡出效果


    }
  }
}
</script>

<style>

.main_div{
  background-image: url("./images/register.png");
  background-size: 100% 100%;
  background-position: 10% 40%;
  background-repeat: no-repeat;
  height: 100%;
  overflow-y: hidden;
}

.font_div{
  float: left;
  margin-left: 7%;
  margin-top: 3%;
  font-size: xxx-large;
  color: orangered;
  font-weight: 1000;
  font-family: 幼圆;
}

.form_div{
  /*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);*/
  background-color: rgba(242,242,240,0.6);
  width: 28%;
  height: 75%;
  margin-right: 13%;
  margin-top: 3%;
  text-align: center;
  border-radius: 4px;
  float: right;
  padding-top: 2%;
}


</style>